const ERROR_CODES = {
  COMPANY_BLOCKED: 'CURRENT_USER_IS_BLOCKED'
};

export default ERROR_CODES;